export const translations = {
  en: {
    title: "HTML Online Viewer",
    preview: "Preview (Full page)",
    highlight: "Highlight (Full page)",
    format: "Format",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    sample: "Sample",
    clear: "Clear",
    importFile: "Import from file",
    exportFile: "Export to file",
    darkMode: "Dark mode",
    privacySettings: "Privacy settings",
    about: "About",
    discoverMore: "Discover more",
    copyright: "OnlineViewer.net",
    aboutTitle: "About",
    aboutDescription: "HTML Online Viewer is a fast HTML editor and formatter with an instant live preview.",
    aboutDescription2: "View, edit and format your HTML in real-time!",
    privacyTitle: "Privacy Settings",
    privacyDescription: "All your HTML code is processed locally in your browser. Nothing is sent to any server.",
    privacyDescription2: "Your privacy is important to us.",
    formatted: "Formatted",
    formattedDesc: "HTML code has been formatted",
    expanded: "Expanded",
    expandedDesc: "All sections expanded",
    collapsed: "Collapsed",
    collapsedDesc: "All sections collapsed",
    imported: "Imported",
    importedDesc: "File loaded successfully",
    exported: "Exported",
    exportedDesc: "HTML file downloaded successfully",
    aiAssistant: "AI Assistant",
    aiHelper: "Need help? I can generate HTML for you!",
    aiPromptPlaceholder: "Describe what you want... (e.g., 'Create a blue button with hover effect')",
    generate: "Generate",
    selectProvider: "Select AI Provider:",
    generating: "Generating...",
    generatedSuccess: "HTML Generated!",
    generatedSuccessDesc: "Your HTML code has been generated successfully",
    generationError: "Generation Error",
    language: "Language"
  },
  tr: {
    title: "HTML Online Görüntüleyici",
    preview: "Önizleme (Tam sayfa)",
    highlight: "Vurgulama (Tam sayfa)",
    format: "Biçimlendir",
    expandAll: "Tümünü genişlet",
    collapseAll: "Tümünü daralt",
    sample: "Örnek",
    clear: "Temizle",
    importFile: "Dosyadan içe aktar",
    exportFile: "Dosyaya aktar",
    darkMode: "Karanlık mod",
    privacySettings: "Gizlilik ayarları",
    about: "Hakkında",
    discoverMore: "Daha fazlasını keşfet",
    copyright: "OnlineViewer.net",
    aboutTitle: "Hakkında",
    aboutDescription: "HTML Online Görüntüleyici, anlık canlı önizleme özelliğine sahip hızlı bir HTML düzenleyici ve biçimlendiricisidir.",
    aboutDescription2: "HTML kodunuzu gerçek zamanlı olarak görüntüleyin, düzenleyin ve biçimlendirin!",
    privacyTitle: "Gizlilik Ayarları",
    privacyDescription: "Tüm HTML kodunuz tarayıcınızda yerel olarak işlenir. Hiçbir şey sunucuya gönderilmez.",
    privacyDescription2: "Gizliliğiniz bizim için önemlidir.",
    formatted: "Biçimlendirildi",
    formattedDesc: "HTML kodu biçimlendirildi",
    expanded: "Genişletildi",
    expandedDesc: "Tüm bölümler genişletildi",
    collapsed: "Daraltıldı",
    collapsedDesc: "Tüm bölümler daraltıldı",
    imported: "İçe Aktarıldı",
    importedDesc: "Dosya başarıyla yüklendi",
    exported: "Dışa Aktarıldı",
    exportedDesc: "HTML dosyası başarıyla indirildi",
    aiAssistant: "AI Asistan",
    aiHelper: "Yardıma mı ihtiyacınız var? Sizin için HTML oluşturabilirim!",
    aiPromptPlaceholder: "Ne istediğinizi açıklayın... (örn: 'Hover efektli mavi bir buton oluştur')",
    generate: "Oluştur",
    selectProvider: "AI Sağlayıcı Seçin:",
    generating: "Oluşturuluyor...",
    generatedSuccess: "HTML Oluşturuldu!",
    generatedSuccessDesc: "HTML kodunuz başarıyla oluşturuldu",
    generationError: "Oluşturma Hatası",
    language: "Dil"
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['en'][key];
};